/* eslint-disable */
import React from 'react';
import { Helmet } from 'react-helmet';

import loadConfiguration from 'ggApp/utils/configuration';
import { getAlternateLinkStores } from 'staticStoreConfig';
import { defaultLanguageByCountry } from 'ggApp/modules/store/constants';

const { APP_CONFIG } = loadConfiguration();
const { shopHost: baseUrl } = APP_CONFIG;

export default class AlternateLocaleLink extends React.Component {
    sanitizeHreflang = (oldLocale, oldCode) => {
        const [locale, code] = [oldLocale, oldCode].map((item) =>
            item.replace(/business[-_]?/gi, ''),
        );
        return `${locale}-${code === '' ? locale : code}`;
    };

    getAlternateInfo = () => {
        const { isBusinessStore, inStores = [], activeStore } = this.props;

        const storeData = getAlternateLinkStores();

        let payload = inStores?.length > 0 ? inStores : storeData;

        const filterByNormalStore = (item) => !/business[-_]?/gi.test(item.code);
        const filterByBusinessStore = (item) => !filterByNormalStore(item);

        /* 
        We should filter the list following the activeStore value, by business and no-business stores.
        */
        payload = payload.filter(isBusinessStore ? filterByBusinessStore : filterByNormalStore);

        const entries = payload.reduce((acc, curr) => {
            const languageKey = (curr.countryCode ?? curr.code).toUpperCase();
            const storeKey = (curr.storeCode ?? curr.code).toLowerCase();
            const hrefLang = this.sanitizeHreflang(defaultLanguageByCountry[languageKey], storeKey);

            const defaultLocale = {
                [hrefLang]: {
                    key: hrefLang,
                    href: `${baseUrl}${this.props.locationPathname.replace(
                        `${activeStore.code}-${this.props.currentLanguage}`,
                        `${curr.storeCode ?? curr.code}-${defaultLanguageByCountry[languageKey]}`,
                    )}`,
                    hrefLang,
                },
            };

            const alternateLocales =
                (curr.languages ?? curr.alternativeLocales)?.reduce((acc, item) => {
                    const hrefLang = this.sanitizeHreflang(
                        item,
                        (curr.storeCode ?? curr.code).toLowerCase(),
                    );

                    acc = {
                        [hrefLang]: {
                            key: hrefLang,
                            href: `${baseUrl}${this.props.locationPathname.replace(
                                `${activeStore.code}-${activeStore.activeLocale}`,
                                `${curr.storeCode ?? curr.code}-${item}`,
                            )}`,
                            hrefLang,
                        },
                    };

                    return acc;
                }, {}) ?? {};

            acc = {
                ...acc,
                ...alternateLocales,
                ...defaultLocale,
            };

            return acc;
        }, {});

        return Object.values(entries);
    };

    render() {
        return (
            <Helmet>
                {this.getAlternateInfo()?.map((ai) => {
                    return (
                        <link
                            key={ai.key}
                            rel="alternate"
                            href={ai.href}
                            hrefLang={ai.hrefLang}
                            data-testid="rel-alternate-testid"
                        />
                    );
                })}
            </Helmet>
        );
    }
}

AlternateLocaleLink.defaultProps = {
    inStores: [],
};
